import { render, staticRenderFns } from "./CouponState.vue?vue&type=template&id=43af0789&scoped=true"
import script from "./CouponState.vue?vue&type=script&lang=js"
export * from "./CouponState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af0789",
  null
  
)

export default component.exports